// extracted by mini-css-extract-plugin
export default {"success-message":"InvitePlayersModal-module--success-message--8iYvp","submit-row":"InvitePlayersModal-module--submit-row--24LvH"};